module.exports = __webpack_public_path__ + "static/media/image_3.c58a7890.svg";